
<div class="md:w-368 mx-auto">
  <JobPostScheduleCard
    id="schedule-type-nanny"
    title="Nanny"
    body="Ongoing, usually 2-5 full weekdays"
    :shadow="false"
    class="mb-16"
  >
    <NannyScheduleIcon />
  </JobPostScheduleCard>

  <Card class="w-full md:p-24">
    <form>
      <fieldset class="mb-16">
        <legend id="schedule-type" class="mb-8 text-strong-body">Schedule type</legend>
        <div class="flex">
          <RadioButton
            id="part-time"
            v-model="nannyScheduleType"
            data-test-id="part-time"
            radioName="schedule_type"
            labelName="Part-time"
            :radioValue="EmploymentTypes.PART_TIME"
            :checked="nannyScheduleType == EmploymentTypes.PART_TIME"
            class="mr-32 pb-24 md:pb-16"
          />
          <RadioButton
            id="full-time"
            v-model="nannyScheduleType"
            data-test-id="full-time"
            radioName="schedule_type"
            labelName="Full-time"
            :radioValue="EmploymentTypes.FULL_TIME"
            :checked="nannyScheduleType == EmploymentTypes.FULL_TIME"
            class="pb-24 md:pb-16"
          />
        </div>
        <div>
          <poppins-date-picker
            id="nanny-schedule-datepicker"
            v-model="startDate"
            data-test-id="nanny-schedule-datepicker"
            labelName="Start date"
            :minDate="minStartDate"
            :maxDate="maxStartDate"
            :status="datepickerStatus"
            :helperText="errors.startDate"
            @input="$delete(errors, 'startDate')"
          />
        </div>

        <Checkbox
          v-model="startDateFlexible"
          data-test-id="start-date-flexible"
          class="mt-16"
          labelName="Start date is flexible"
          checkboxId="start-date-flexible"
        />
      </fieldset>

      <fieldset>
        <legend id="day-times" class="mb-8 text-strong-body">Days and time</legend>

        <fieldset>
          <legend class="mb-8 text-subtitle font-medium">Weekdays (Monday–Friday):</legend>
          <Checkbox
            key="weekday-morning"
            v-model="nannyDayTimes"
            data-test-id="weekday-morning"
            labelName="Morning (before school)"
            checkboxId="weekday-morning"
            :value="NannyHours.WEEKDAY_MORNING"
          />
          <Checkbox
            key="weekday-daytime"
            v-model="nannyDayTimes"
            data-test-id="weekday-daytime"
            labelName="Daytime"
            checkboxId="weekday-daytime"
            :value="NannyHours.WEEKDAY_DAY"
          />
          <Checkbox
            key="weekday-afternoon"
            v-model="nannyDayTimes"
            data-test-id="weekday-afternoon"
            labelName="Afternoon (after school)"
            checkboxId="weekday-afternoon"
            :value="NannyHours.WEEKDAY_AFTERNOON"
          />
          <Checkbox
            key="weekday-evening"
            v-model="nannyDayTimes"
            data-test-id="weekday-evening"
            labelName="Evening"
            checkboxId="weekday-evening"
            :value="NannyHours.WEEKDAY_EVENING"
          />
        </fieldset>

        <fieldset>
          <legend class="mb-8 text-subtitle font-medium">Weekends (Saturday, Sunday):</legend>
          <Checkbox
            key="weekend-daytime"
            v-model="nannyDayTimes"
            data-test-id="weekend-daytime"
            labelName="Daytime"
            checkboxId="weekend-daytime"
            :value="NannyHours.WEEKENDS_DAY"
          />
          <Checkbox
            key="weekend-evening"
            v-model="nannyDayTimes"
            data-test-id="weekend-evening"
            labelName="Evening"
            checkboxId="weekend-evening"
            :value="NannyHours.WEEKENDS_EVENING"
          />
        </fieldset>
      </fieldset>

      <HelperText v-if="errors.dayTimes" :text="errors.dayTimes" :status="HelperStatus.Error" />

      <div class="flex flex-row-reverse mt-32">
        <RouteStepperNextButton
          :stepData="reviewSection"
          :draftData="draftData"
          :validate="validate"
          @errors="errors = $event"
        />
      </div>
    </form>
  </Card>
</div>
